// Max length of catatan reviewer (mirrors profileReviewNotesMaxLen in user-service)
export const REVIEW_NOTES_MAX = 500
